import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store/store";
import { INotificationState } from "./definitions";

const initialState: INotificationState = {
    toastMap: new Map(),
};

export const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        updateToastMap: (state, action: PayloadAction<Map<string, any>>) => {
            state.toastMap = action.payload;
        },
    },
});

export const { updateToastMap } = notificationsSlice.actions;

export const selectNotifications = (state: RootState) => state.notifications;
export const notificationsReducer = notificationsSlice.reducer;
